export class TagType {
    ID;
    TagType;
    constructor({id, tagType}) {
        this.ID = id;
        this.TagType = tagType;
    }
}